import Hoc from './Hoc';
import { CerebralError } from 'cerebral';
export default function connect(dependencies, passedComponent) {
    return Hoc(dependencies, passedComponent);
}
export function ConnectFactory() {
    function returned() {
        return {
            with: function (connector) {
                return {
                    to: function (passedComponent) {
                        var con = getConnector(connector);
                        return connect(con, passedComponent);
                    },
                    toClass: function (passedComponent) {
                        var fakeProps = getFakeProps();
                        var con = getConnector(connector);
                        return connect(con, passedComponent(fakeProps));
                    },
                };
            },
        };
    }
    return returned;
}
export function ModuleConnectFactory() {
    function To(stateLookup, signalsLookup) {
        return function returned() {
            return {
                with: function (connector) {
                    return {
                        to: function (passedComponent) {
                            var con = getConnector(connector, { stateLookup: stateLookup, signalsLookup: signalsLookup });
                            return connect(con, passedComponent);
                        },
                        toClass: function (passedComponent) {
                            var fakeProps = getFakeProps();
                            var con = getConnector(connector, { stateLookup: stateLookup, signalsLookup: signalsLookup });
                            return connect(con, passedComponent(fakeProps));
                        },
                    };
                },
            };
        };
    }
    return { To: To };
}
function getFakeProps() {
    var handler = {
        get: function (target, name) {
            throw new CerebralError('The props lambda parameter should only be used to conveniently get the type of the components generic props parameter. Use `this.props` in the component instead.');
        },
    };
    var fakeProps = Proxy ? new Proxy({}, handler) : {};
    return fakeProps;
}
function getConnector(connector, lookups) {
    var con;
    if (lookups) {
        con = function (x) {
            return connector({
                state: x.state,
                signals: x.signals,
                module: {
                    state: lookups.stateLookup(x.state),
                    signals: lookups.signalsLookup(x.signals),
                },
                props: x.props,
            });
        };
    }
    else {
        con = connector;
    }
    return con;
}
//# sourceMappingURL=connect.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/connect.js
// module id = 150
// module chunks = 0